




import Vue, { PropType } from 'vue'
import { DeliveryTimeCandidate, XDayOfWeek } from '@/types/generated/graphql'
import XRadioGroup, {
  OptionEntry,
} from '@/components/atoms/Radio/XRadioGroup.vue'
import formatEnum from '@/plugins/filters/formatEnum'
import { dayOfWeekOf } from '@/plugins/moment'

type Props = {
  value?: XDayOfWeek
  candidates: DeliveryTimeCandidate[]
}

type Computed = {
  localValue?: XDayOfWeek
  options: OptionEntry<XDayOfWeek>[]
}

export default Vue.extend<{}, {}, Computed, Props>({
  inheritAttrs: false,
  name: 'DeliveryDayOfWeekPicker',
  components: { XRadioGroup },
  props: {
    value: {
      type: String as PropType<XDayOfWeek>,
    },
    candidates: {
      type: Array,
    },
  },
  computed: {
    localValue: {
      get() {
        return this.value
      },
      set(value) {
        this.$emit('input', value)
      },
    },
    options() {
      if (!this.candidates) {
        // 必ずDeliveryTimeCandidateから生成する
        return []
      }

      return this.candidates.map((candidate) => {
        const dayOfWeek = dayOfWeekOf(candidate.date)
        return {
          value: dayOfWeek,
          label: formatEnum(dayOfWeek, 'xDayOfWeek'),
        }
      })
    },
  },
})
